import ActivityAppState from '../apps/activities/state'

export default class State extends Backbone.Model {
  get defaults () {
    return {
      settings: null,
      user: null,
      participant: null,
      slideVisible: false,
      presenting: false
    }
  }

  get legacySession () {
    return this.backboneSessionHelper.session
  }

  initialize (attrs = {}, options = {}) {
    // Track states for apps
    this.appStates = {
      activities: new ActivityAppState({
        user: attrs.user,
        mode: attrs.mode,
        role: 'agave',
        checkable: false,
        showTrash: false
      })
    }
  }

  inspect () {
    const result = super.toJSON()

    // Deal with state model attributes whose values are complex types
    result.participant = this.get('participant')?.toJSON()
    result.settings = this.get('settings')?.toJSON()
    result.user = this.get('user')?.toJSON().user

    // session only has references to the participant and user, which we otherwise have anyway
    delete result.session

    // Deal with state object properties tacked on outside of the underlying Backbone.Model
    result.appStates = {}
    Object.entries(this.appStates).forEach(([key, value]) => {
      result.appStates[key] = value.inspect()
    })

    return result
  }
}
